/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_EndInputs */

const en_us2_workout_end = /** @type {(inputs: Workout_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

const pt_br2_workout_end = /** @type {(inputs: Workout_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar`)
};

const es_419_workout_end = /** @type {(inputs: Workout_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar`)
};

const pt_pt2_workout_end = /** @type {(inputs: Workout_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar`)
};

const fr_fr2_workout_end = /** @type {(inputs: Workout_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer`)
};

const de_de2_workout_end = /** @type {(inputs: Workout_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beenden`)
};

const it_it2_workout_end = /** @type {(inputs: Workout_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina`)
};

/**
* | output |
* | --- |
* | "End" |
*
* @param {Workout_EndInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_end = /** @type {((inputs?: Workout_EndInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_EndInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_end(inputs)
	if (locale === "es-419") return es_419_workout_end(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_end(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_end(inputs)
	if (locale === "de-DE") return de_de2_workout_end(inputs)
	if (locale === "it-IT") return it_it2_workout_end(inputs)
	return en_us2_workout_end(inputs)
});
export { workout_end as "workout.end" }